import React from "react";
import { Link } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";

const Container = tw.div`relative max-w-xl mx-auto px-4 sm:px-8 py-20 md:py-24 text-center`;
const Heading = tw.h1`text-3xl md:text-4xl font-black text-gray-900 leading-tight`;
const Description = tw.p`mt-6 text-base md:text-lg text-secondary-100 leading-relaxed`;
const Actions = tw.div`mt-10 flex flex-col sm:flex-row items-center justify-center gap-4`;
const PrimaryLink = tw(PrimaryButtonBase)`rounded-full`;
const SecondaryLink = tw(Link)`font-semibold text-primary-500 hover:text-primary-700 transition duration-300`;

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <Heading>Thank you for reaching out</Heading>
        <Description>
          We received your message and will get back to you soon at the email you provided.
        </Description>
        <Actions>
          <PrimaryLink as={Link} to="/">Back to Home</PrimaryLink>
          <SecondaryLink to="/#our-products">See Our Products</SecondaryLink>
        </Actions>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
